/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR GPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE files in the repository root for full details.
*/

import SdkConfig, { DEFAULTS } from "../SdkConfig";

export interface MobileAppUrls {
    ios?: string;
    android?: string;
    fdroid?: string;
}

export const getConfiguredMobileAppUrls = (): MobileAppUrls => {
    const config = SdkConfig.get();
    const usesElementDefaults = config.brand === DEFAULTS.brand;

    const configuredUrl = (platform: keyof MobileAppUrls): string | undefined => {
        const value = config.mobile_builds?.[platform] ?? undefined;
        return usesElementDefaults || value !== DEFAULTS.mobile_builds[platform] ? value : undefined;
    };

    return {
        ios: configuredUrl("ios"),
        android: configuredUrl("android"),
        fdroid: configuredUrl("fdroid"),
    };
};
